const extractGridStateFilters = function (gridState) {
  var scrubbedFilters = {
    dateFilters: [],
    singleValueFilters: [],
    arrayValueFilters: [],
    totalFilters: 0,
  };

  if (!gridState) return scrubbedFilters;

  var gridFilters = gridState.filters || gridState;
  var filters = [];

  // Extract filter indices from keys ending with numbers
  var filterIndices = [];
  Object.keys(gridFilters).forEach(function (key) {
    var match = key.match(/\d+$/);
    if (match && filterIndices.indexOf(match[0]) === -1) {
      filterIndices.push(match[0]);
    }
  });

  // Build filter objects
  filterIndices.forEach(function (index) {
    var filter = {
      filtercondition: gridFilters["filtercondition" + index],
      filterdatafield: gridFilters["filterdatafield" + index],
      filteroperator: gridFilters["filteroperator" + index],
      filtertype: gridFilters["filtertype" + index],
      filtervalue: gridFilters["filtervalue" + index],
    };

    // Add operator key if it exists
    var operatorKey = filter.filterdatafield + "operator";
    if (gridFilters[operatorKey]) {
      filter[operatorKey] = gridFilters[operatorKey];
    }

    if (filter.filtervalue !== "Please Choose:") {
      filters.push(filter);
    }
  });

  // Separate date filters from other filters
  var dateFilters = filters.filter(function (f) {
    return f.filtertype === "datefilter";
  });

  var nonDateFilters = filters.filter(function (f) {
    return f.filtertype !== "datefilter";
  });

  // Group non-date filters by datafield
  var filterGroups = {};
  nonDateFilters.forEach(function (filter) {
    var field = filter.filterdatafield;
    if (!filterGroups[field]) {
      filterGroups[field] = [];
    }
    filterGroups[field].push(filter);
  });

  // Separate single value and array value filters
  Object.keys(filterGroups).forEach(function (field) {
    var group = filterGroups[field];
    if (group.length === 1) {
      scrubbedFilters.singleValueFilters.push(group[0]);
    } else {
      scrubbedFilters.arrayValueFilters =
        scrubbedFilters.arrayValueFilters.concat(group);
    }
  });

  // Add date filters
  if (dateFilters.length > 0) {
    scrubbedFilters.dateFilters = dateFilters;
  }

  // Calculate total filters
  scrubbedFilters.totalFilters =
    scrubbedFilters.dateFilters.length +
    scrubbedFilters.singleValueFilters.length +
    scrubbedFilters.arrayValueFilters.length;

  return scrubbedFilters;
};

const applyFilters = (filters, $grid) => {
  const mergedFilters = filters.reduce((acc, filter) => {
    const matches = filters.filter(
      (f) => f.filterdatafield === filter.filterdatafield
    );
    if (!acc[filter.filterdatafield]) {
      acc[filter.filterdatafield] = matches;
    }
    return acc;
  }, {});

  Object.keys(mergedFilters).forEach((key) => {
    const filterGrp = new $.jqx.filter();
    mergedFilters[key].forEach((filter) => {
      const f = filterGrp.createfilter(
        filter.filtertype,
        filter.filtervalue,
        filter.filtercondition
      );
      filterGrp.addfilter(filter.filteroperator, f);
    });

    $grid.jqxGrid("addfilter", key, filterGrp, true);
  });
};

const removeFilters = ($grid) => {
  const filterInfo = $grid.jqxGrid("getfilterinformation");

  if (filterInfo && filterInfo.length) {
    filterInfo.forEach((filter) => {
      if (filter.datafield) {
        $grid.jqxGrid("removefilter", filter.datafield);
      }
    });
  }
};

const loadGridState = (state, $grid, columns) => {
  if (state != null && $grid != null) {
    if (state.columns) {
      const defaultColumnState = {
        pinned: false,
        width: 100,
        hidden: true,
      };

      const usedIndexes = new Set();
      const savedColumns = state.columns ?? {};
      const newCols = columns.filter((x) => x.pinned); // get pinned

      newCols.forEach((col) => {
        if (!usedIndexes.has(col.index)) {
          usedIndexes.add(col.index);
        }
      });

      // Process non-pinned columns
      Object.keys(savedColumns)
        .filter((key) => !newCols.find((x) => x.datafield === key)) // filter out initial pinned columns
        .forEach((datafield) => {
          const savedCol = savedColumns[datafield];
          let columnIndex = savedCol?.index;

          if (!isNaN(columnIndex) && !usedIndexes.has(columnIndex)) {
            usedIndexes.add(columnIndex);
          } else {
            columnIndex = 0;
            while (usedIndexes.has(columnIndex)) {
              columnIndex++;
            }
            usedIndexes.add(columnIndex);
          }

          const gridCol =
            columns.find((col) => col.datafield === datafield) || {};
          newCols.push({
            ...defaultColumnState,
            ...gridCol,
            ...savedCol,
            index: columnIndex,
          });
        });

      // Add any missing grid columns that are not in state.columns
      columns
        .filter((x) => !x.pinned)
        .filter((x) => !newCols.find((y) => y.datafield === x.datafield)) // filter out saved columns
        .forEach((col) => {
          if (!savedColumns[col.datafield]) {
            let columnIndex = 0;
            while (usedIndexes.has(columnIndex)) {
              columnIndex++;
            }
            usedIndexes.add(columnIndex);

            newCols.push({
              ...defaultColumnState,
              ...col,
              index: columnIndex,
            });
          }
        });

      // Sort columns by index
      newCols.sort((a, b) => a.index - b.index);
      //$grid.jqxGrid({ columns: newCols });

      $grid.jqxGrid("beginupdate");
      for (let i = 0; i < newCols.length; i++) {
        const col = newCols[i];
        if (!col.pinned && col.datafield) {
          $grid.jqxGrid("setcolumnindex", col.datafield, i);
          $grid.jqxGrid("setcolumnproperty", col.datafield, "width", col.width);
          $grid.jqxGrid(
            "setcolumnproperty",
            col.datafield,
            "hidden",
            col.hidden
          );
        }
      }
      $grid.jqxGrid("endupdate");
    }

    if (state.sortcolumn) {
      const direction = state.sortdirection.ascending ? "asc" : "desc";
      $grid.jqxGrid("sortby", state.sortcolumn, direction);
    } else {
      $grid.jqxGrid("removesort");
    }

    removeFilters($grid);
    if (state.filters && state.filters?.filterscount > 0) {
      const filters = extractGridStateFilters(state);

      const allFilters = Object.keys(filters).reduce((acc, key) => {
        const f = filters[key] ?? [];
        if (Array.isArray(f)) {
          acc.push(...f);
        }
        return acc;
      }, []);

      if (allFilters.length) {
        applyFilters(allFilters, $grid);
      }
    }

    $grid.jqxGrid("refreshfilterrow");
  }
};

function jqxCustomEvents() {
  const attachEvents = () => {
    (function ($) {
      // Example custom wrapper + custom event - jqx grid does not have a 'gridstatechanged' event,
      // this is custom. You can listen to it like $(yourGrid).on("gridstatechanged", function(event) {...})

      // Save a reference to the original loadstate method to callback.
      const originalLoadStateFn = $.jqx._jqxGrid.prototype.loadstate;
      let isLoadingState = false;
      // Override the loadstate method with our custom method
      $.jqx._jqxGrid.prototype.loadstate = function (state) {
        state = state ?? {};
        isLoadingState = true;

        // Call the original loadstate method
        // NOTE: jqxGrid state is bugged, use the cutom loadGridState function instead.
        //const result = originalLoadStateFn.call(this, state);

        // Working around the jqxGrid state bug, we will use our custom loadGridState function.
        // This will load the grid state, including columns, sorting, and filters.
        loadGridState(state, $(this.host), this.columns.records ?? []);

        // Here is the magic, trigger a custom event
        $(this.host).trigger("gridstatechanged", [state]);

        isLoadingState = false;
        $(this.host).jqxGrid("updatebounddata", "data");

        // Return the result of the original method, so everything else 'acts' like normal.
        //return result;
      };

      const orginalUpdateBoundData = $.jqx._jqxGrid.prototype.updatebounddata;
      $.jqx._jqxGrid.prototype.updatebounddata = function (type) {
        if (isLoadingState) {
          return;
        }

        // Doesn't return anything...
        orginalUpdateBoundData.call(this, type);
        $(this.host).trigger("updatebounddata", [type]);
      };

      // JQX Grid internal bug fix...Bug in jqxGrid with filtertypes: 'list', it adds empty filters to the filter array
      // causing it to throw errors.
      const originalAddFilterWidget = $.jqx._jqxGrid.prototype._addfilterwidget;
      $.jqx._jqxGrid.prototype._addfilterwidget = function (
        column,
        gridInstance,
        width
      ) {
        //debugger
        const mainJqx = this.that;
        const dataview = mainJqx.dataview;
        const filters = dataview.filters ?? [];

        for (let i = 0; i < filters.length; i++) {
          const filterData = filters[i];
          if (
            filterData &&
            filterData.datafield === column.datafield &&
            column.filtertype === "list"
          ) {
            const columnFilter = filterData.filter.getfilters()[0] ?? {};
            columnFilter.value = columnFilter.value ?? "";

            // The fix. When null or no value, remove it from the internal list.
            if (!columnFilter.value) {
              this.that.dataview.removefilter(column.datafield, true);
            }
          }
        }

        // Doesn't return anything, just call it.
        originalAddFilterWidget.call(this, column, gridInstance, width);
      };

      // ...Add additional method wrappers, custom events here ...
    })(jQuery);
  };

  return {
    attachEvents,
  };
}

const instance = jqxCustomEvents();
export default instance;
